import { passCodes } from '../passCodes';
import cipher32Hint1 from '../../../../assets/images/games/zdar-escape-game/ciphers/32/hint1.webp';
import track32 from '../../../../assets/audio/tracks/track32.mp3';
import track32Snow from '../../../../assets/audio/tracks/track32-snow.mp3';

export const step32statue = {
    id: 30,
    title: '14. stanoviště',
    taskText: `
        <p>
            Hmm zajímavé, tu jsme přece už viděli na začátku, tak to nám to teda bylo hodně platný. Ještě mu prý tady na náměstí musíme najít vavřín, že ten nás dovede dál. 
        </p>
        <p>    
            Kde by ten vavřín mohl jenom být? Prý u něj bude nějaká tabulka, podle které poznáme, že jsme správně. Až ho najdeš, zadej nejvyšší číslo z tabulky.
        </p>
    `,
    snowTaskText: `
        <p>
            Hmm zajímavé, tu jsme přece už viděli na začátku, tak to nám to teda bylo hodně platný. Ještě mu prý tady na náměstí musíme najít vavřín, že ten nás dovede dál. 
        </p>
        <p>    
            Kde by ten vavřín mohl jenom být?
        </p>
    `,
    catImage: 4,
    audio: track32,
    cipher: {
        images: [cipher32Hint1],
    },
    snowCipher: {
        images: [cipher32Hint1],
    },
    snowAudio: track32Snow,
    codeInputText: 'Zadejte kód',
    codeInputPassCodeRegexp: passCodes[23],
    additionalInfo: 'Odpovědí je číslo.',
    hints: [
        {
            text: 'Jedná se o poměrně novou sochu pana Vavřína Krčila.',
        },
        {
            text: 'Kódem je: 1968',
            solution: true,
        },
    ],
    snowHints: [
        {
            text: 'Jedná se o poměrně novou sochu pana Vavřína Krčila.',
        },
    ],
};
